// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.view-report-page {
  background: #f6f7f9;
  min-height: 100vh;
  padding: 40px 16px;
}

.view-report-container {
  max-width: 650px;
  margin: 0 auto;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
  padding: 7px;
}

.report-header {
  border-bottom: 1px solid #e5e7eb;
  padding-bottom: 20px;
}

.report-toc {
  margin: 18px 10px 10px;
  padding: 16px 18px;
  background: #ffffff;
  border: 1px solid #dbe7ff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(47, 128, 237, 0.08);
}

.report-toc-title {
  margin: 0;
  color: #1f2937;
  font-size: 1.05rem;
  font-weight: 700;
}

.report-toc-list {
  margin: 10px 0 0;
  padding-left: 20px;
}

.report-toc-item {
  margin-bottom: 8px;
}

.report-toc-link {
  color: #2f80ed;
  text-decoration: none;
  overflow-wrap: anywhere;
}

.report-toc-link:hover,
.report-toc-link:focus-visible {
  text-decoration: underline;
}

.report-header h1 {
  margin: 0 0 12px;
  font-size: 2rem;
}

.report-meta {
  display: flex;
  gap: 24px;
  font-size: 0.95rem;
  color: #555;
  flex-wrap: wrap;
}

.report-section {
  margin: 10px;
}

.report-section h2 {
  font-size: 1.4rem;
  margin-bottom: 16px;
}

.report-image-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 16px;
}

.report-image-grid img {
  width: 100%;
  border-radius: 8px;
  object-fit: cover;
  border: 1px solid #e5e7eb;
}

.report-markdown {
  font-size: 1rem;
  line-height: 1.3;
  color: #222;
}

.report-markdown p,
.report-markdown li {
  scroll-margin-top: 88px;
}

.report-markdown h1,
.report-markdown h2,
.report-markdown h3 {
  margin-top: 28px;
  margin-bottom: 12px;
}

.report-markdown strong {
  font-weight: 600;
}

.report-state {
  max-width: 720px;
  margin: 80px auto;
  text-align: center;
  color: #555;
}

.report-state.error {
  color: #b91c1c;
}

@media (max-width: 640px) {
  .view-report-page {
    padding: 24px 12px;
  }

  .view-report-container {
    border-radius: 10px;
  }

  .report-header h1 {
    font-size: 1.7rem;
  }

  .report-toc {
    margin-left: 8px;
    margin-right: 8px;
    padding: 14px 16px;
  }

  .report-toc-list {
    padding-left: 18px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/stylesheets/ViewReport.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,0CAA0C;EAC1C,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;;;EAGE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".view-report-page {\n  background: #f6f7f9;\n  min-height: 100vh;\n  padding: 40px 16px;\n}\n\n.view-report-container {\n  max-width: 650px;\n  margin: 0 auto;\n  background: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);\n  padding: 7px;\n}\n\n.report-header {\n  border-bottom: 1px solid #e5e7eb;\n  padding-bottom: 20px;\n}\n\n.report-toc {\n  margin: 18px 10px 10px;\n  padding: 16px 18px;\n  background: #ffffff;\n  border: 1px solid #dbe7ff;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(47, 128, 237, 0.08);\n}\n\n.report-toc-title {\n  margin: 0;\n  color: #1f2937;\n  font-size: 1.05rem;\n  font-weight: 700;\n}\n\n.report-toc-list {\n  margin: 10px 0 0;\n  padding-left: 20px;\n}\n\n.report-toc-item {\n  margin-bottom: 8px;\n}\n\n.report-toc-link {\n  color: #2f80ed;\n  text-decoration: none;\n  overflow-wrap: anywhere;\n}\n\n.report-toc-link:hover,\n.report-toc-link:focus-visible {\n  text-decoration: underline;\n}\n\n.report-header h1 {\n  margin: 0 0 12px;\n  font-size: 2rem;\n}\n\n.report-meta {\n  display: flex;\n  gap: 24px;\n  font-size: 0.95rem;\n  color: #555;\n  flex-wrap: wrap;\n}\n\n.report-section {\n  margin: 10px;\n}\n\n.report-section h2 {\n  font-size: 1.4rem;\n  margin-bottom: 16px;\n}\n\n.report-image-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));\n  gap: 16px;\n}\n\n.report-image-grid img {\n  width: 100%;\n  border-radius: 8px;\n  object-fit: cover;\n  border: 1px solid #e5e7eb;\n}\n\n.report-markdown {\n  font-size: 1rem;\n  line-height: 1.3;\n  color: #222;\n}\n\n.report-markdown p,\n.report-markdown li {\n  scroll-margin-top: 88px;\n}\n\n.report-markdown h1,\n.report-markdown h2,\n.report-markdown h3 {\n  margin-top: 28px;\n  margin-bottom: 12px;\n}\n\n.report-markdown strong {\n  font-weight: 600;\n}\n\n.report-state {\n  max-width: 720px;\n  margin: 80px auto;\n  text-align: center;\n  color: #555;\n}\n\n.report-state.error {\n  color: #b91c1c;\n}\n\n@media (max-width: 640px) {\n  .view-report-page {\n    padding: 24px 12px;\n  }\n\n  .view-report-container {\n    border-radius: 10px;\n  }\n\n  .report-header h1 {\n    font-size: 1.7rem;\n  }\n\n  .report-toc {\n    margin-left: 8px;\n    margin-right: 8px;\n    padding: 14px 16px;\n  }\n\n  .report-toc-list {\n    padding-left: 18px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
